<template>
  <v-card
    color="grey darken-3"
    dark
  >
    <v-card-text>
      <avatar />
      <div class="text-sm-center mb-4 mt-3">
        <h1>
          José Henrique <span class="light-blue--text text--lighten-3">Lincoln</span>
        </h1>
        <span>
          Engenheiro de Software apaixonado por Aprender
        </span>
      </div>

      <sidebar-section :options="sections.info" />
      <sidebar-section :options="sections.socials" />
      <sidebar-section :options="sections.hobbies">
        <template v-slot:item="{item}">
          <v-chip>
            <v-avatar>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>
      <sidebar-section :options="sections.languages">
        <template v-slot:items="{items}">
          <v-container pa-0>
            <v-layout
              wrap
              class="text-xs-center"
            >
              <template
                v-for="(item, i) in items"
              >
                <v-flex
                  :key="i"
                  md3
                  sm4
                  xs6
                >
                  <v-progress-circular
                    rotate="360"
                    size="65"
                    width="2"
                    :value="item.value"
                    color="white"
                    class="ma-2"
                  >
                    {{ item.text }}
                  </v-progress-circular>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </template>
      </sidebar-section>
    </v-card-text>
  </v-card>
</template>

<script>
import Avatar from '@/views/dark-template/sidebar/Avatar'
import SidebarSection from '@/views/dark-template/sidebar/Section'
export default {
  name      : 'Sidebar',
  components: { SidebarSection, Avatar },
  data () {
    return {
      sections: {
        info: {
          title: 'INFO',
          items: [
            {
              name: 'Email',
              icon: 'mdi-email',
              text: 'lincoln19922@gmail.com',
            },
            {
              name: 'Website',
              icon: 'mdi-web',
              text: 'jhlincoln.com.br',
            },
            {
              name: 'Birth Date',
              icon: 'mdi-cake-variant',
              text: 'Feb 18, 1992',
            },
            {
              name: 'Habitation',
              icon: 'mdi-map-marker',
              text: 'São Paulo, Brasil',
            },
          ],
        },
        socials: {
          title: 'SOCIALS',
          items: [
            {
              icon: 'mdi-bitbucket',
              text: 'bitbucket.org/lincoln19922/',
              link: 'https://bitbucket.org/lincoln19922/',
            },
            {
              icon: 'mdi-linkedin-box',
              text: 'linkedin.com/in/henriquelincoln',
              link: 'https://www.linkedin.com/in/henriquelincoln/',
            },
            // {
            //   icon: 'mdi-twitter',
            //   text: 'twitter.com/lincoln19922',
            //   link: 'https://twitter.com/lincoln19922',
            // },
            {
              icon: 'mdi-instagram',
              text: 'instagram.com/lincoln19922',
              link: 'https://www.instagram.com/lincoln19922/',
            },
          ],
        },
        hobbies: {
          title: 'HOBBIES',
          items: [
            {
              icon: 'mdi-biohazard',
              text: 'Challenges',
            },
            {
              icon: 'mdi-bike',
              text: 'Cycling',
            },
            {
              icon: 'mdi-image-filter-hdr',
              text: 'Nature',
            },
            {
              icon: 'mdi-teach',
              text: 'Teaching',
            },
            {
              icon: 'mdi-music',
              text: 'Music',
            },
            {
              icon: 'mdi-account-group',
              text: 'Leadership',
            },
            {
              icon: 'mdi-guitar-acoustic',
              text: 'Guitar Acoustic!',
            },
            {
              icon: 'mdi-glass-mug',
              text: 'Some Beers',
            },
            {
              icon: 'mdi-finance',
              text: 'Finance',
            },
          ],
        },
        languages: {
          title: 'LANGUAGES',
          items: [
            {
              text : 'English',
              value: 56,
            },
            {
              text : 'Português',
              value: 100,
            },
          ],
        },
      },
    }
  },
}
</script>

<style scoped>
.sidebar{
    background: #2e2e2e;
}
</style>
